import { useTranslation } from "react-i18next";

import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

import { type OverviewData } from "../../types";
import { adaptOverviewTiles } from "./adapter";
import { TILE_ORDER } from "./config";
import { TileCard } from "./TileCard";

interface OverviewTilesProps {
  /** The all-time `overview` block of the activity dashboard. */
  totals: Partial<OverviewData>;
  administratorsCount: number;
  representativesCount: number;
  /** External users have no access to the farmers list, so its "View" link is hidden. */
  isExternalUser?: boolean;
}

export function OverviewTiles({
  totals,
  administratorsCount,
  representativesCount,
  isExternalUser = false,
}: OverviewTilesProps) {
  const { t } = useTranslation();

  const tiles = adaptOverviewTiles(
    { totals, administratorsCount, representativesCount, isExternalUser },
    t
  );

  return (
    <section className="grid items-start gap-6 lg:grid-cols-3">
      {TILE_ORDER.map(entityType => (
        <TileCard key={entityType} tile={tiles[entityType]} />
      ))}
    </section>
  );
}

export function OverviewTilesSkeleton() {
  return (
    <section className="grid items-start gap-6 lg:grid-cols-3">
      {TILE_ORDER.map(entityType => (
        <Card key={entityType} className="gap-0 p-0">
          <div className="flex items-center gap-3 p-4 pb-0">
            <Skeleton className="size-10 shrink-0 rounded-md" />
            <Skeleton className="h-6 w-28" />
            <Skeleton className="ml-auto h-6 w-10" />
          </div>
          <div className="flex items-center gap-2 p-4 pl-17">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="ml-auto h-5 w-10" />
          </div>
        </Card>
      ))}
    </section>
  );
}
